import React, { useEffect, useState } from 'react';
import '../assets/css/profile.css';
import { FaEdit, FaRegSave, FaTimes } from 'react-icons/fa';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { toast } from 'react-toastify';
import { getCustomerById, updateWooCustomer } from '../Api/customer';

const Profile = () => {
    const token = localStorage.getItem('auth_token');
    const [userData] = useState(JSON.parse(localStorage.getItem("user_data")));
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        username: '',
        phone: '',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        postcode: '',
        country: ''
    });

    useEffect(() => {
        async function fetchProfile() {
            try {
                if (!token || !userData?.id) return;
                const customer = await getCustomerById(userData.id, token);           

                setFormData({
                    fullName: `${customer?.billing?.first_name || ''} ${customer?.billing?.last_name || ''}`.trim(),
                    email: customer?.billing?.email || '',
                    username: userData.username || '',
                    phone: customer?.billing?.phone || '',
                    address_1: customer?.billing?.address_1 || '',
                    address_2: customer?.billing?.address_2 || '',
                    city: customer?.billing?.city || '',
                    state: customer?.billing?.state || '',
                    postcode: customer?.billing?.postcode || '',
                    country: customer?.billing?.country || ''
                });
            } catch (error) {
                toast.error('Failed to load profile');
            }
        }
        fetchProfile();
    }, [token, userData?.id, userData?.username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const [first_name = '', ...lastNameParts] = formData.fullName.split(' ');
            const last_name = lastNameParts.join(' ');

            const addressPayload = {
                address_1: formData.address_1,
                address_2: formData.address_2,
                city: formData.city,
                state: formData.state,
                postcode: formData.postcode,
                country: formData.country,
                first_name,
                last_name
            };

            const payload = {
                billing: { ...addressPayload, email: formData.email, phone: formData.phone },
                shipping: addressPayload
            };

            await updateWooCustomer(userData.id, token, payload);
            toast.success('Profile updated successfully');
            setIsEditing(false);
            setIsModalOpen(false);
        } catch (error) {
            toast.error('Update failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen">
            <main className="container main-wrapper">
                <h1 className="page-title">User Details</h1>
                <div className="content-grid">
                    {/* LEFT COLUMN */}
                    <div className="left-column">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="card-title">Personal Information</h2>
                                <button className="action-btn" onClick={isEditing ? handleSave : () => setIsEditing(true)}>
                                    {isEditing ? <FaRegSave /> : <FaEdit />}
                                    <span>{isEditing ? 'Save' : 'Edit'}</span>
                                </button>
                            </div>
                            <form className="form-grid">
                                <div className="form-group"><label>Full Name</label><input name="fullName" className="form-input" value={formData.fullName} onChange={handleChange} readOnly={!isEditing} /></div>
                                <div className="form-group"><label>Email</label><input name="email" className="form-input" value={formData.email} onChange={handleChange} readOnly={!isEditing} /></div>
                                <div className="form-group"><label>Username</label><input className="form-input" value={formData.username} readOnly /></div>
                                <div className="form-group"><label>Phone</label><input name="phone" className="form-input" value={formData.phone} onChange={handleChange} readOnly={!isEditing} /></div>
                            </form>
                        </div>
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="sidebar-stack">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Shipping Address</h3>
                                <button className="icon-btn" onClick={() => setIsModalOpen(true)}><IoMdAddCircleOutline size={22} /></button>
                            </div>
                            <div className="address-display-box">
                                <p><strong>{formData.address_1}</strong></p>
                                {formData.address_2 && <p>{formData.address_2}</p>}
                                <p>{formData.city}, {formData.state} {formData.postcode}</p>
                                <p>{formData.country}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* ADDRESS MODAL */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content card">
                        <div className="card-header">
                            <h3>Update Address</h3>
                            <button onClick={() => setIsModalOpen(false)} className="close-btn"><FaTimes /></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group"><label>Address Line 1</label><input name="address_1" className="form-input" value={formData.address_1} onChange={handleChange} /></div>
                            <div className="form-group"><label>Address Line 2</label><input name="address_2" className="form-input" value={formData.address_2} onChange={handleChange} /></div>
                            <div className="form-row">
                                <div className="form-group"><label>City</label><input name="city" className="form-input" value={formData.city} onChange={handleChange} /></div>
                                <div className="form-group"><label>State</label><input name="state" className="form-input" value={formData.state} onChange={handleChange} /></div>
                            </div>
                            <div className="form-row">
                                <div className="form-group"><label>Postcode</label><input name="postcode" className="form-input" value={formData.postcode} onChange={handleChange} /></div>
                                <div className="form-group"><label>Country</label><input name="country" className="form-input" value={formData.country} onChange={handleChange} /></div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
                            <button className="btn-primary" onClick={handleSave} disabled={loading}>{loading ? 'Saving...' : 'Update Address'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Profile;